var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForeignUniversity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 21.2,
    viewBox: "0 0 33 21.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1080",
    "data-name": "Groupe 1080",
    transform: "translate(-5081.78 -860.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1079",
    "data-name": "Groupe 1079",
    transform: "translate(5096.329 860.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11048",
    "data-name": "Trac\\xE9 11048",
    d: "M5128.074,860.065h-14.857a1.793,1.793,0,0,0-1.8,1.792v10.332a1.8,1.8,0,0,0,1.8,1.8h10.636l3.676,3.156v-3.156h.545a1.8,1.8,0,0,0,1.8-1.8V861.857A1.793,1.793,0,0,0,5128.074,860.065Zm-4.972,11.313a.493.493,0,0,1-.625-.3l-.829-2.376h-2.643l-.829,2.376a.491.491,0,1,1-.927-.323l2.613-7.49a.491.491,0,0,1,.927,0l2.614,7.49A.492.492,0,0,1,5123.1,871.378Z",
    transform: "translate(-5111.42 -860.065)",
    fill: "#77a395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11049",
    "data-name": "Trac\\xE9 11049",
    d: "M5127.572,872.748h1.957l-.979-2.8Z",
    transform: "translate(-5119.644 -865.095)",
    fill: "#77a395"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11050",
    "data-name": "Trac\\xE9 11050",
    d: "M5098.125,879.239a2.782,2.782,0,0,1-2.778-2.778v-8.006h-11.775a1.794,1.794,0,0,0-1.792,1.8v10.332a1.789,1.789,0,0,0,1.792,1.792h.545v3.161l3.682-3.161h10.636a1.792,1.792,0,0,0,1.792-1.792v-1.345Zm-5.208-5.512h-5.245a7.75,7.75,0,0,0,1.782,2.936,12.177,12.177,0,0,0,1.278-1.794.491.491,0,0,1,.861.472,12.653,12.653,0,0,1-1.416,1.992,9.026,9.026,0,0,0,2.01,1.246.491.491,0,1,1-.407.893,9.953,9.953,0,0,1-2.279-1.427,6.364,6.364,0,0,1-2.63,1.613.5.5,0,0,1-.13.018.491.491,0,0,1-.129-.965,5.33,5.33,0,0,0,2.168-1.339,8.7,8.7,0,0,1-2.13-3.646h-.66a.491.491,0,0,1,0-.982h2.951v-.968a.491.491,0,0,1,.982,0v.968h3a.491.491,0,1,1,0,.982Z",
    transform: "translate(0 -4.272)",
    fill: "#77a395"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeignUniversity);
export default __webpack_public_path__ + "static/media/foreign_university.1c002c42d59ea6e6441cb5800e4b3bd0.svg";
export { ForwardRef as ReactComponent };